import React from "react";

function Header({ user }) {

    return(
       <div class="topnav"> 
    
       {/* <img class="logo" src="" alt=""/> */}
       <img class="logo" src="https://i.ibb.co/37mS8RF/Habibi-Mezze-3.png" alt=""/>
        {/* <h1 class="habibi">Habibi Mezze</h1> */}
        <br></br>
      <br></br>
        {/* <h5>Hello, is habibi hungry?</h5> */}
        {/* <div class="oval" >Im an Oval</div> */}
       </div> 
    )
    
}








export default Header; 